var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h2',[_vm._v("Оплата заказа")]),_c('button',{staticClass:"pay-btn",on:{"click":_vm.pay}},[_vm._v("Оплатить")])])}
var staticRenderFns = []

export { render, staticRenderFns }